import React, { useState, useEffect } from 'react'
import {
  Box,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TablePagination,
  Typography,
  CircularProgress,
  Alert,
  Button
} from '@mui/material'
import moment from 'moment-jalaali'
import PaymentModal from '../PaymentModal/PaymentModal'
import { useTheme } from '@mui/material/styles'
moment.loadPersian({ usePersianDigits: true })

const API_BASE_URL = 'https://api.neontradepro.com'

function PurchaseHistory() {
  const [history, setHistory] = useState<any[]>([])
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState('')
  const [page, setPage] = useState(0)
  const [rowsPerPage, setRowsPerPage] = useState(5)
  const [showPaymentModal, setShowPaymentModal] = useState(false)
  const [selectedInvoiceForPayment, setSelectedInvoiceForPayment] = useState<any>(null)
  const theme = useTheme()

  useEffect(() => {
    const fetchHistory = async () => {
      setLoading(true)
      setError('')
      try {
        const response = await fetch(`${API_BASE_URL}/invoice/plan`, {
          headers: { Authorization: `Bearer ${localStorage.getItem('token')}` }
        })
        if (!response.ok) {
          if (response.status === 404) {
            setHistory([])
            return
          }
          throw new Error('خطا در بارگذاری تاریخچه خریدها')
        }
        const data = await response.json()
        setHistory(data.reverse())
      } catch (err: any) {
        setError(err.message)
      } finally {
        setLoading(false)
      }
    }
    fetchHistory()
  }, [])

  const handleChangePage = (event: unknown, newPage: number) => setPage(newPage)
  const handleChangeRowsPerPage = (event: React.ChangeEvent<HTMLInputElement>) => {
    setRowsPerPage(parseInt(event.target.value, 10))
    setPage(0)
  }

  const handlePayInvoice = (invoice: any) => {
    setSelectedInvoiceForPayment(invoice)
    setShowPaymentModal(true)
  }

  const handleClosePaymentModal = () => {
    setShowPaymentModal(false)
    setSelectedInvoiceForPayment(null)
  }

  if (loading)
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', my: 4 }}>
        <CircularProgress />
      </Box>
    )
  if (error) return <Alert severity='error'>{error}</Alert>

  const invoiceStatusMap: { [key: string]: string } = {
    payment_pending: 'در انتظار پرداخت',
    success: 'پرداخت شده',
    failed: 'ناموفق'
  }
  const invoiceColorsMap: { [key: string]: string } = {
    payment_pending: '#ff9800',
    success: '#0be818',
    failed: '#f44336'
  }

  return (
    <Box>
      {history.length === 0 ? (
        <Typography>تاریخچه خریدی برای نمایش وجود ندارد.</Typography>
      ) : (
        <>
          <TableContainer className='themed-table-container'>
            <Table>
              <TableHead>
                <TableRow>
                  {['محصول', 'تاریخ پرداخت', 'مبلغ (دلار)', 'وضعیت', 'اقدامات'].map(h => (
                    <TableCell key={h}>{h}</TableCell>
                  ))}
                </TableRow>
              </TableHead>
              <TableBody>
                {history.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map(row => (
                  <TableRow key={row.id}>
                    <TableCell>
                      {row.plan.title} - {row.plan.duration} روزه
                    </TableCell>

                    <TableCell>{row.paid_at ? moment(row.paid_at * 1000).format('jYYYY/jMM/jDD') : '---'}</TableCell>

                    <TableCell>${(row.price / 100).toLocaleString('en-US')}</TableCell>
                    <TableCell>
                      <Box sx={{ color: invoiceColorsMap[row.status] }}>
                        {invoiceStatusMap[row.status] || 'خطا در دریافت وضعیت'}
                      </Box>
                    </TableCell>
                    <TableCell>
                      {row.status === 'payment_pending' && (
                        <Button
                          variant='contained'
                          sx={{
                            backgroundColor: invoiceColorsMap['payment_pending'],
                            '&:hover': { backgroundColor: '#e68900' }
                          }}
                          onClick={() => handlePayInvoice(row)}
                        >
                          پرداخت
                        </Button>
                      )}
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
          <TablePagination
            component='div'
            count={history.length}
            page={page}
            onPageChange={handleChangePage}
            rowsPerPage={rowsPerPage}
            onRowsPerPageChange={handleChangeRowsPerPage}
            labelRowsPerPage='تعداد در صفحه'
            rowsPerPageOptions={[5, 10, 25]}
          />
        </>
      )}

      {showPaymentModal && selectedInvoiceForPayment && (
        <PaymentModal
          plan={{
            id: selectedInvoiceForPayment.plan.id || 0,
            name: selectedInvoiceForPayment.plan.title,
            price: selectedInvoiceForPayment.price / 100,
            period: selectedInvoiceForPayment.period_label || 'نامشخص'
          }}
          onClose={handleClosePaymentModal}
          invoiceId={selectedInvoiceForPayment.id}
          theme={theme.palette.mode}
        />
      )}
    </Box>
  )
}

export default PurchaseHistory
